import * as React from "react";
import { PrimaryTooltip } from "Components/Shared/PrimaryTooltip";
import { PrimaryModal } from "Components/Shared/PrimaryModal";
import { TrashCanIcon } from "Components/Shared/Icons/TrashCanIcon";
import { Resources, useResource } from "Translations/Resources";
import { Typography } from "@material-ui/core";
import { CompanyDto } from "Api/Api";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { deleteCompaniesAsync } from "State/Companies/CompanyReducer";
import { useHistory } from "react-router-dom";

type Props = {
  company: CompanyDto | null;
};

const StyledModalBody = styled.div`
  margin-bottom: ${props => props.theme.spacing(4)}px;

  & > * {
    &:last-of-type {
      font-weight: 500;
    }
  }
`;

export const CompanyDetailConfirmModal: React.FunctionComponent<Props> = props => {
  const { company } = props;
  const { t } = useResource();
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = React.useState(false);
  const [isDeleted, setDeleted] = React.useState(false);

  React.useEffect(() => {
    if (isDeleted) {
      redirectToCompanyList();
    }
    // eslint-disable-next-line
  }, [isDeleted]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    if (company) {
      dispatch(deleteCompaniesAsync.request(company.companyID));
      setDeleted(true);
    }
  };

  const redirectToCompanyList = () => {
    history.replace(`/${t(Resources.Routes.Companies)}`);
  };

  return (
    <>
      <PrimaryModal
        open={open}
        onClose={handleClose}
        onSuccess={handleSuccess}
        successBtnText={t(Resources.Common.Delete)}
        closeBtnText={t(Resources.Common.Cancel)}
        title={t(Resources.HumanResources.Employees.Detail.Delete.ConfirmTitle)}
      >
        <StyledModalBody>
          <Typography>
            {t(Resources.Companies.List.Delete.ConfirmText)}
          </Typography>
          <Typography>{company?.name}</Typography>
        </StyledModalBody>
      </PrimaryModal>
      <PrimaryTooltip title={t(Resources.Companies.List.Delete.Tooltip)}>
        <button className={"bl-btn bl-btn-orange"} onClick={_ => setOpen(true)}>
          <TrashCanIcon fill={"#ffffff"} />
        </button>
      </PrimaryTooltip>
    </>
  );
};
